import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal/modal.service';
import { QuizService } from 'src/app/services/quiz/quiz.service';
import { SnackbarService } from './../../../services/snackbar/snackbar.service';

@Component({
  selector: 'app-change-respondent-name',
  templateUrl: './change-respondent-name.component.html',
  styleUrls: ['./change-respondent-name.component.scss'],
})
export class ChangeRespondentNameComponent implements OnInit {

  constructor(
    private quizService: QuizService,
    private modalService: ModalService,
    private snackbarService: SnackbarService
  ) { }

  @Input() quizReportId: number | undefined;
  @Input() name = '';

  ngOnInit() {}

  onClickSubmit(): void {
    if (this.quizReportId === undefined) {
      return;
    }
    if (this.name === '') {
      this.snackbarService.openSnackBar(SnackbarService.NOT_ANSWERED_NAME);
      return;
    }
    this.quizService.updateQuizReport(this.quizReportId, { respondentFirstName: this.name }).subscribe(() => {
      this.snackbarService.openSnackBar(SnackbarService.QUIZ_REPORT_NAME_CHANGED); 
      this.modalService.dismiss({changedName: this.name});
    })
  }
}
